/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import processStepStyle from "./processStepStyle";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import checkMarkImage from "@/src/assets/img/planner/icon_check_64px.png";
import { Box, Stack, Theme } from "@mui/material";
import { SxProps } from "@mui/system";

type ProcessStepProps = {
  headline: string;
  icon: string | React.ComponentType<{ sx?: SxProps<Theme> }>;
  text: React.ReactNode;
  hideConnector?: boolean;
  checked?: boolean;
};

const ProcessStep = ({ icon, headline, text, checked = false, hideConnector = false }: ProcessStepProps) => {
  const IconComponent = icon;

  return (
    <Grid container>
      <Grid size={3}>
        <Stack sx={processStepStyle.iconContainer}>
          <Box sx={processStepStyle.progressIcons}>
            <Paper sx={processStepStyle.imageCircle}>
              {checked ? <Box component={"img"} sx={processStepStyle.img} src={checkMarkImage} alt={headline} /> : <IconComponent sx={processStepStyle.img} />}
            </Paper>
          </Box>
          {!hideConnector && <Box sx={processStepStyle.connectorLine} />}
        </Stack>
      </Grid>
      <Grid sx={processStepStyle.textBlock} size={9}>
        <Box sx={processStepStyle.stepHeading}>{headline}</Box>
        {!checked && <Box>{text}</Box>}
      </Grid>
    </Grid>
  );
};

export default ProcessStep;
